import React from "react";
import ListingPanel from "./ListingPanel";

// Gastronomie, Ferienhäuser, … share one schema (listing table) and one
// panel; each type still is its own module/tab. Adding a type: a row in
// `listing_type` + `topic`, and one createListingModule() line in the registry.
export function createListingModule(type, fallbackLabel) {
  function Panel() {
    return <ListingPanel type={type} />;
  }
  Panel.displayName = `ListingPanel(${type})`;

  return { fallbackLabel, Panel };
}
